/* src/modules/dashboard/api.js */

import gql from 'graphql-tag';

export const FETCH_DASHBOARD_LESSONS_QUERY = gql`
  query fetchDashboardLessons($lessonSearchInput: LessonSearchInput!) {
    lessons(filter: $lessonSearchInput) {
      _id
      price
      status
      current {
        startTime {
          timestamp
        }
        timeslots {
          _id
        }
      }
      tutorFee
      studentFee
      studentPenalty
      help {
        type
      }
      charges {
        creditsUsed
      }
      timeline {
        type
        emitter
        date {
          timestamp
        }
      }
    }
  }
`;

export const FETCH_DASHBOARD_USERS_QUERY = gql`
  query fetchDashboardUsers($userSearchInput: UserSearchInput!) {
    users(input: $userSearchInput) {
      _id
      howDidYouHear
    }
  }
`;

export const FETCH_DASHBOARD_STUDENTS_QUERY = gql`
  query fetchDashboardStudents($studentSearchInput: StudentSearchInput) {
    students(input: $studentSearchInput) {
      _id
      credits
      createdAt {
        timestamp
      }
      referred {
        _id
      }
    }
  }
`;

export const FETCH_DASHBOARD_TUTORS_QUERY = gql`
  query fetchDashboardTutors($tutorSearchInput: TutorSearchInput) {
    tutors(input: $tutorSearchInput) {
      _id
      createdAt {
        timestamp
      }
    }
  }
`;

export const FETCH_POPULAR_COURSES_QUERY = gql`
  query fetchPopularCourses($university: ID!, $organization: ID!, $limit: Int!) {
    popularCourses(_university: $university, _organization: $organization, limit: $limit) {
      course {
        _id
        subject
        number
      }
      completedLessons
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/dashboard/api.js